export const CONCILIATION_TAB_KEYS = {
  RELATORIOS_GERAIS: {
    CONCILIACOES_ATRASADAS: "conciliacoes-atrasadas",
    GERACAO_DE_EXCEL: "geracao-de-excel",
  },
  RELATORIOS_VAR: {
    MOVIMENTO_DE_CAIXA: "movimento-de-caixa",
    LISTAGEM_ITENS_VENDIDOS: "listagem-itens-vendidos",
  },
  EMAILS: {
    EMAILS_DE_LOJA: "emails-de-loja",
    HISTORICO: "historico",
    EMAILS_DE_SETORES: "emails-de-setores",
  },
  CONFIGURACOES: {
    ATRIBUICAO_DE_ANALISTA: "atribuicao-de-analista",
    REGIONAIS: "regionais",
    JUSTIFICATIVAS: "justificativas",
    CONTA_CONTABIL: "conta-contabil",
  },
  DASHBOARD: {
    PAINEL: "painel",
    TRILHA_DE_AUDITORIA: "trilha-de-auditoria",
  },
  DTEF: {
    PENDENCIAS: "pendencias",
    FORMAS_DE_PAGAMENTO: "formas-de-pagamento",
  },
} as const;
